/**
 * Google Consent Mode v2 – push managed consent to Google Tag Manager / gtag.
 * See: https://developers.google.com/tag-platform/security/guides/consent?consentmode=advanced#tag-manager_1
 *
 * Default consent must be set in index.html before any tag loads.
 * This module pushes consent updates when the user accepts or declines in our banner.
 */

const CONSENT_GRANTED = {
  ad_storage: 'granted',
  ad_user_data: 'granted',
  ad_personalization: 'granted',
  analytics_storage: 'granted',
};

const CONSENT_DENIED = {
  ad_storage: 'denied',
  ad_user_data: 'denied',
  ad_personalization: 'denied',
  analytics_storage: 'denied',
};

/**
 * Push consent update to GTM/gtag. Call when user accepts or declines tracking.
 * Safe to call before gtag.js loads – commands are queued in dataLayer.
 * @param {boolean} granted - true = user accepted analytics/ads; false = essential only
 */
export function pushConsentUpdate(granted) {
  if (typeof window === 'undefined') return;
  window.dataLayer = window.dataLayer || [];
  const gtag = window.gtag;
  if (typeof gtag === 'function') {
    gtag('consent', 'update', granted ? CONSENT_GRANTED : CONSENT_DENIED);
  } else {
    window.dataLayer.push(['consent', 'update', granted ? CONSENT_GRANTED : CONSENT_DENIED]);
  }
}

/**
 * Object to set as default consent (denied). Used in index.html script.
 * Export for documentation; actual default is set in index.html before any tag.
 */
export const DEFAULT_CONSENT_DENIED = CONSENT_DENIED;
